import { CommonLayout } from '../commonComponents';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import MyProfileMain from '.';
import VerifySubbrokerOtp from './VerifySubbrokerOtp';

const routerList = [
    {
        name: 'My Profile',
        path: "",
        component: MyProfileMain,
        exact: true,
    },
    {
        name: 'Verify OTP',
        path: "otp-screen",
        component: VerifySubbrokerOtp,
    }
]

function MyProfileRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => <Route
                    exact={item.exact}
                    key={index}
                    path={item.path ? `${path}/${item.path}` : path}
                    component={item.component}
                />)
            }
        </Switch>
    );
}

export default function MyProfileRouter(): JSX.Element {
    return (
        <CommonLayout>
            <MyProfileRoutes />
        </CommonLayout>
    )
}
